import css from "./Dot.module.css"
const Dot=({children, style})=>{
    return(
        <span><span className={css.dot} style={style}>{children}</span></span>
    )
}
export default Dot;